import { useI18n } from '../i18n';

export default function LanguageToggle() {
  const { lang, setLang } = useI18n();
  const next = lang === 'en' ? 'ar' : 'en';

  const handleLanguageChange = () => {
    setLang(next);
    if (window.plausible) {
      window.plausible('Language Toggle', { props: { from: lang, to: next } });
    }
  };

  return (

    <button
      onClick={handleLanguageChange}
      className="flex items-center space-x-2 px-3 py-2 rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors duration-200"
      aria-label="Switch language"
    >
      <div className="w-4 h-4 rounded-full overflow-hidden flex-shrink-0">
        <img 
          src={lang === 'en' ? 'https://flagcdn.com/w20/sa.png' : 'https://flagcdn.com/w20/us.png'}
          alt={lang === 'en' ? 'Saudi Arabia' : 'United States'}
          className="w-full h-full object-cover"
        />
      </div>
      <span className="text-sm font-medium">
        {lang === 'en' ? 'العربية' : 'English'}
      </span>
    </button>
  );
}